import React from 'react';
import { Divider } from '@fortress-technology-solutions/fortress-component-library/Atoms';

const SectionDivider = () => <Divider sx={{ width: '100%', marginY: 2 }} />;

export default SectionDivider;
